import gsap from "gsap";
export class RegularBanner {
  constructor(el) {
    this.DOM = {
      el: el,
      isAutoplay: false,
      autoplay_speed: "",
    };

    if ($(".index-regular-banner").length === 0) {
      return;
    }
    this.init();
  }
  init() {
    const interleaveOffset = 0.5; //视差比值
    const _autoplay =
      $(".index-regular-banner").attr("data-autoplay") === "true"
        ? true
        : false;
    this.DOM.isAutoplay = _autoplay;
    const _speed = Number($(".index-regular-banner").attr("data-delay")) || 5;
    this.DOM.autoplay_speed = _speed;
    var swiperlength = $(".index-regular-banner .swiper-slide").length;
    if (swiperlength == 1) {
      $(`.index-regular-banner .swiper-wrapper`).addClass("disabled");
      $(`.index-regular-banner .slideshow-pagination`).addClass("disabled");
      $(`.index-regular-banner .slideshow-pagination`).css("display", "none");
    }

    function animateSlideContent(swiper) {
      var activeSlide = swiper.slides[swiper.activeIndex];
      if (activeSlide) {
        var contents = activeSlide.querySelectorAll(".regular-animate");
        contents.forEach((content, index) => {
          setTimeout(() => {
            content.classList.add("active");
          }, index * 100);
        });
      }
    }

    function resetSlideContent(swiper) {
      var allSlides = swiper.slides;
      allSlides.forEach((slide) => {
        var contents = slide.querySelectorAll(".regular-animate");
        contents.forEach((content) => {
          content.classList.remove("active");
        });
      });
    }
    // var self = this;
    this.swiperGsap = new Swiper(".index-regular-banner .swiper-container", {
      simulateTouch: false,
      followFinger: false,
      autoplay: _autoplay
        ? {
            delay: _speed * 1000,
            disableOnInteraction: false,
            reverseDirection: false,
          }
        : false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      speed: 500,
      keyboard: true,
      loop: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      preloadImages: true,
      updateOnImagesReady: true,
      observer: true, // 开启动态检查器，监测swiper和slide
      observeParents: true, // 监测Swiper 的祖/父元素
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      pagination: {
        el: ".index-regular-banner .slideshow-pagination",
        clickable: true,
        bulletClass: "slideshow-pagination-item",
        bulletActiveClass: "active pagination-active",
        clickableClass: "slideshow-pagination-clickable",
        modifierClass: "slideshow-pagination-",
        renderBullet: function (index, className) {
          var slideIndex = index,
            number = index <= 8 ? "0" + (slideIndex + 1) : slideIndex + 1;

          var paginationItem = '<span class="slideshow-pagination-item">';
          paginationItem =
            index <= 8
              ? paginationItem +
                '<span class="pagination-separator"><span class="pagination-separator-loader"></span></span>'
              : paginationItem;
          paginationItem += "</span>";
          return paginationItem;
        },
      },
      on: {
        init: function () {
          animateSlideContent(this);
        },
        slideChangeTransitionStart: function () {
          resetSlideContent(this);
        },
        progress: function (swiper) {
          for (var i = 0; i < swiper.slides.length; i++) {
            var slideProgress = swiper.slides[i].progress;
            var innerOffset = swiper.width * interleaveOffset;
            var innerTranslate = slideProgress * innerOffset;
            swiper.slides[i].querySelector(".slide-inner").style.transform =
              "translate3d(" + innerTranslate + "px, 0, 0)";
          }
        },
        touchStart: function (swiper) {
          for (var i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = "";
          }
        },
        setTransition: function (swiper, speed) {
          for (var i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = speed + "ms";
            swiper.slides[i].querySelector(".slide-inner").style.transition =
              speed + "ms";
          }
        },
        slideChangeTransitionEnd: function () {
          animateSlideContent(this);
          const curSlide = Array.from(this.slides).filter((it) =>
            it.classList.contains("swiper-slide-active")
          );
          const curImg = $(curSlide).find("img")[0];
          // 兜底防止白屏
          if (curImg) {
            curImg.classList.remove("lazyloading");
            curImg.classList.add("lazyloaded");
          }
        },
        resize: function () {
          setTimeout(() => {
            this.update(); //窗口变化时，更新Swiper的一些属性，如宽高等
          }, 500);
        },
      },
    });
    this.initEvents();
  }

  initEvents() {
    this.swiperGsap.on("paginationUpdate", (swiper, paginationEl) =>
      setTimeout(() => {
        this.pageAnimatePagination(swiper, paginationEl);
      }, 20)
    );

    this.pageAnimatePagination();
  }

  pageAnimatePagination(swiper, paginationEl) {
    if(this.DOM.isAutoplay){
      const DOC =
      paginationEl || this.DOM.el.querySelector(".slideshow-pagination");
      let paginationItemsLoader = DOC.querySelectorAll(
        ".pagination-separator-loader"
      );
      let activePaginationItem = DOC.querySelector(".pagination-active");
      let activePaginationItemLoader = activePaginationItem?.querySelector(
        ".pagination-separator-loader"
      );
      gsap.set(paginationItemsLoader, {
        scaleX: 0,
      });
      gsap.to(activePaginationItemLoader, this.DOM.autoplay_speed, {
        startAt: {
          scaleX: 0,
        },
        scaleX: 1,
        ease: "linear",
      });
    }
  }
}
